import React, { ChangeEvent, FC, FocusEvent, useEffect, useRef, WheelEvent } from 'react';
import { ListItem, TextField, Typography, Unstable_Grid2 as Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';

import { LeaderboardConfig, LeaderboardEventScores } from 'api';
import theme from 'theme';

const styles = {
  input: {
    width: theme.spacing(8),
    backgroundColor: theme.palette.grey[100],

    '& input[type=number]': {
      '-moz-appearance': 'textfield',
      textAlign: 'center',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
};

interface Props {
  index: number;
  item: LeaderboardEventScores;
  bucket: string;
}

const ScoringItem: FC<Props> = ({ bucket, item, index }) => {
  const { t } = useTranslation();
  const { setFieldValue } = useFormikContext<LeaderboardConfig>();
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.addEventListener('wheel', onWheel, { passive: false });
    return () => inputRef.current?.removeEventListener('wheel', onWheel, { passive: false });
  }, []);

  function onChange(event: ChangeEvent<HTMLInputElement>) {
    const { value } = event.target;

    setFieldValue(`${bucket}[${index}].score`, value);
  }

  function onBlur(event: FocusEvent<HTMLInputElement>) {
    const { value } = event.target;

    if (value === '') {
      setFieldValue(`${bucket}[${index}].score`, 0);
    }
  }

  function onWheel(event: WheelEvent<HTMLInputElement>) {
    event.preventDefault();
  }

  return (
    <ListItem disableGutters>
      <Grid xs={12} container justifyContent="space-between">
        <Grid xs={10} container alignItems="center">
          <Typography variant="body2">{t(`leaderboard:admin_${item.event}`)}</Typography>
        </Grid>

        <Grid xs={2} container justifyContent="flex-end">
          <TextField
            variant="standard"
            ref={inputRef}
            type="number"
            value={Number(item.score).toString()}
            sx={styles.input}
            onChange={onChange}
            onBlur={onBlur}
          />
        </Grid>
      </Grid>
    </ListItem>
  );
};

export default ScoringItem;
